import React, { useEffect, useState, useRef } from 'react';
import { Check, ChevronDown } from 'lucide-react';
const TIERS = [{
  name: 'Standard',
  color: 'Emerald',
  tailwind: 'text-emerald-400',
  hex: '#34D399',
  bg: 'bg-emerald-500/20',
  border: 'border-emerald-500/30',
  lightText: 'text-emerald-700',
  lightBg: 'bg-emerald-100',
  lightBorder: 'border-emerald-200'
}, {
  name: 'Level 1',
  color: 'Blue',
  tailwind: 'text-blue-400',
  hex: '#60A5FA',
  bg: 'bg-blue-500/20',
  border: 'border-blue-500/30',
  lightText: 'text-blue-700',
  lightBg: 'bg-blue-100',
  lightBorder: 'border-blue-200'
}, {
  name: 'Level 2',
  color: 'Amber',
  tailwind: 'text-amber-400',
  hex: '#FBBF24',
  bg: 'bg-amber-500/20',
  border: 'border-amber-500/30',
  lightText: 'text-amber-700',
  lightBg: 'bg-amber-100',
  lightBorder: 'border-amber-200'
}, {
  name: 'Level 3',
  color: 'Purple',
  tailwind: 'text-purple-400',
  hex: '#C084FC',
  bg: 'bg-purple-500/20',
  border: 'border-purple-500/30',
  lightText: 'text-purple-700',
  lightBg: 'bg-purple-100',
  lightBorder: 'border-purple-200'
}, {
  name: 'Level 4',
  color: 'Rose',
  tailwind: 'text-rose-400',
  hex: '#FB7185',
  bg: 'bg-rose-500/20',
  border: 'border-rose-500/30',
  lightText: 'text-rose-700',
  lightBg: 'bg-rose-100',
  lightBorder: 'border-rose-200'
}, {
  name: 'Level 5',
  color: 'Cyan',
  tailwind: 'text-cyan-400',
  hex: '#22D3EE',
  bg: 'bg-cyan-500/20',
  border: 'border-cyan-500/30',
  lightText: 'text-cyan-700',
  lightBg: 'bg-cyan-100',
  lightBorder: 'border-cyan-200'
}, {
  name: 'Level 6',
  color: 'Orange',
  tailwind: 'text-orange-400',
  hex: '#FB923C',
  bg: 'bg-orange-500/20',
  border: 'border-orange-500/30',
  lightText: 'text-orange-700',
  lightBg: 'bg-orange-100',
  lightBorder: 'border-orange-200'
}, {
  name: 'Level 7',
  color: 'Lime',
  tailwind: 'text-lime-400',
  hex: '#A3E635',
  bg: 'bg-lime-500/20',
  border: 'border-lime-500/30',
  lightText: 'text-lime-700',
  lightBg: 'bg-lime-100',
  lightBorder: 'border-lime-200'
}, {
  name: 'Level 8',
  color: 'Indigo',
  tailwind: 'text-indigo-400',
  hex: '#818CF8',
  bg: 'bg-indigo-500/20',
  border: 'border-indigo-500/30',
  lightText: 'text-indigo-700',
  lightBg: 'bg-indigo-100',
  lightBorder: 'border-indigo-200'
}, {
  name: 'Level 9',
  color: 'Pink',
  tailwind: 'text-pink-400',
  hex: '#F472B6',
  bg: 'bg-pink-500/20',
  border: 'border-pink-500/30',
  lightText: 'text-pink-700',
  lightBg: 'bg-pink-100',
  lightBorder: 'border-pink-200'
}, {
  name: 'Level 10',
  color: 'Teal',
  tailwind: 'text-teal-400',
  hex: '#2DD4BF',
  bg: 'bg-teal-500/20',
  border: 'border-teal-500/30',
  lightText: 'text-teal-700',
  lightBg: 'bg-teal-100',
  lightBorder: 'border-teal-200'
}, {
  name: 'Level 11',
  color: 'Fuchsia',
  tailwind: 'text-fuchsia-400',
  hex: '#E879F9',
  bg: 'bg-fuchsia-500/20',
  border: 'border-fuchsia-500/30',
  lightText: 'text-fuchsia-700',
  lightBg: 'bg-fuchsia-100',
  lightBorder: 'border-fuchsia-200'
}, {
  name: 'Level 12',
  color: 'Sky',
  tailwind: 'text-sky-400',
  hex: '#38BDF8',
  bg: 'bg-sky-500/20',
  border: 'border-sky-500/30',
  lightText: 'text-sky-700',
  lightBg: 'bg-sky-100',
  lightBorder: 'border-sky-200'
}, {
  name: 'Level 13',
  color: 'Red',
  tailwind: 'text-red-400',
  hex: '#F87171',
  bg: 'bg-red-500/20',
  border: 'border-red-500/30',
  lightText: 'text-red-700',
  lightBg: 'bg-red-100',
  lightBorder: 'border-red-200'
}];
function DemoDropdown({
  isDark
}: {
  isDark: boolean;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedTiers, setSelectedTiers] = useState<Set<string>>(new Set());
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);
  const allSelected = selectedTiers.size === 0;
  const selectedCount = selectedTiers.size;
  let buttonLabel = 'All Levels';
  if (selectedCount === 1) buttonLabel = Array.from(selectedTiers)[0];else if (selectedCount > 1) buttonLabel = `${selectedCount} Levels`;
  const handleToggle = (tier: string) => {
    if (tier === 'All') {
      setSelectedTiers(new Set());
      return;
    }
    setSelectedTiers(prev => {
      const next = new Set(prev);
      if (next.has(tier)) next.delete(tier);else next.add(tier);
      return next;
    });
  };
  return <div ref={dropdownRef} className="relative inline-block" data-id="element-2955">
      <button onClick={() => setIsOpen(!isOpen)} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-medium transition-all whitespace-nowrap border
          ${isDark ? 'bg-white/5 border-white/10 text-white/70 hover:bg-white/10 hover:text-white' : 'bg-gray-100 border-gray-200 text-gray-600 hover:bg-gray-200 hover:text-gray-900'}
          ${isOpen ? isDark ? 'bg-white/10 border-white/20 text-white' : 'bg-gray-200 border-gray-300 text-gray-900' : ''}`} data-id="element-2956">
        <span data-id="element-2957">{buttonLabel}</span>
        <ChevronDown className={`w-3 h-3 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-2958" />
      </button>
      {isOpen && <div className={`absolute top-full left-0 mt-1.5 z-50 min-w-[200px] max-h-[320px] rounded-xl border shadow-2xl backdrop-blur-xl overflow-y-auto
            ${isDark ? 'bg-slate-900/95 border-white/10' : 'bg-white/95 border-gray-200'}`} data-id="element-2959">
          <button onClick={() => handleToggle('All')} className={`w-full flex items-center gap-2.5 px-3 py-2 text-left transition-colors
              ${isDark ? 'hover:bg-white/5' : 'hover:bg-gray-50'}
              ${allSelected ? isDark ? 'bg-cyan-500/10' : 'bg-teal-500/5' : ''}`} data-id="element-2960">
            <div className={`w-4 h-4 rounded flex items-center justify-center border transition-all flex-shrink-0
              ${allSelected ? isDark ? 'bg-cyan-500 border-cyan-400' : 'bg-teal-600 border-teal-500' : isDark ? 'border-white/20 bg-white/5' : 'border-gray-300 bg-white'}`} data-id="element-2961">
              {allSelected && <Check className="w-3 h-3 text-white" data-id="element-2962" />}
            </div>
            <span className={`text-xs font-medium ${isDark ? 'text-white/80' : 'text-gray-700'}`} data-id="element-2963">
              All Levels
            </span>
            <span className={`text-[10px] ml-auto ${isDark ? 'text-white/30' : 'text-gray-400'}`} data-id="element-2964">
              {TIERS.length}
            </span>
          </button>
          <div className={`mx-3 border-t ${isDark ? 'border-white/5' : 'border-gray-100'}`} data-id="element-2965" />
          {TIERS.map(tier => {
        const isChecked = selectedTiers.has(tier.name);
        return <button key={tier.name} onClick={() => handleToggle(tier.name)} className={`w-full flex items-center gap-2.5 px-3 py-2 text-left transition-colors
                  ${isDark ? 'hover:bg-white/5' : 'hover:bg-gray-50'}
                  ${isChecked ? isDark ? 'bg-cyan-500/10' : 'bg-teal-500/5' : ''}`} data-id="element-2966">
                <div className={`w-4 h-4 rounded flex items-center justify-center border transition-all flex-shrink-0
                  ${isChecked ? isDark ? 'bg-cyan-500 border-cyan-400' : 'bg-teal-600 border-teal-500' : isDark ? 'border-white/20 bg-white/5' : 'border-gray-300 bg-white'}`} data-id="element-2967">
                  {isChecked && <Check className="w-3 h-3 text-white" data-id="element-2968" />}
                </div>
                <span className={`text-[9px] font-bold px-1.5 py-0.5 rounded border ${isDark ? `${tier.tailwind} ${tier.bg} ${tier.border}` : `${tier.lightText} ${tier.lightBg} ${tier.lightBorder}`}`} data-id="element-2969">
                  {tier.name}
                </span>
              </button>;
      })}
        </div>}
    </div>;
}
export function LevelsPage() {
  const [isDark, setIsDark] = useState(true);
  return <div className={`min-h-screen w-full ${isDark ? 'bg-slate-950 text-white' : 'bg-white text-gray-900'}`} data-id="element-2970">
      <div className="max-w-4xl mx-auto px-8 py-12" data-id="element-2971">
        {/* Header */}
        <div className="flex items-center justify-between mb-10" data-id="element-2972">
          <div data-id="element-2973">
            <h1 className="text-2xl font-bold mb-1" data-id="element-2974">Tier Levels Reference</h1>
            <p className={`text-sm ${isDark ? 'text-white/50' : 'text-gray-500'}`} data-id="element-2975">
              14 pricing tiers with unique color assignments for the options
              gallery
            </p>
          </div>
          <button onClick={() => setIsDark(!isDark)} className={`px-4 py-2 rounded-lg text-sm font-medium border transition-colors ${isDark ? 'bg-white/5 border-white/10 hover:bg-white/10' : 'bg-gray-100 border-gray-200 hover:bg-gray-200'}`} data-id="element-2976">
            {isDark ? '☀️ Light Mode' : '🌙 Dark Mode'}
          </button>
        </div>

        {/* Live Dropdown Demo */}
        <div className={`rounded-xl border p-6 mb-10 ${isDark ? 'bg-slate-900/50 border-white/10' : 'bg-gray-50 border-gray-200'}`} data-id="element-2977">
          <h2 className="text-sm font-bold uppercase tracking-wider mb-4 opacity-60" data-id="element-2978">
            Live Dropdown
          </h2>
          <DemoDropdown isDark={isDark} data-id="element-2979" />
        </div>

        {/* Reference Table */}
        <div className={`rounded-xl border overflow-hidden ${isDark ? 'border-white/10' : 'border-gray-200'}`} data-id="element-2980">
          <table className="w-full" data-id="element-2981">
            <thead data-id="element-2982">
              <tr className={isDark ? 'bg-white/5' : 'bg-gray-50'} data-id="element-2983">
                <th className={`text-left text-[11px] font-bold uppercase tracking-wider px-5 py-3 ${isDark ? 'text-white/50' : 'text-gray-500'}`} data-id="element-2984">
                  Tier
                </th>
                <th className={`text-left text-[11px] font-bold uppercase tracking-wider px-5 py-3 ${isDark ? 'text-white/50' : 'text-gray-500'}`} data-id="element-2985">
                  Tag Preview
                </th>
                <th className={`text-left text-[11px] font-bold uppercase tracking-wider px-5 py-3 ${isDark ? 'text-white/50' : 'text-gray-500'}`} data-id="element-2986">
                  Color Family
                </th>
                <th className={`text-left text-[11px] font-bold uppercase tracking-wider px-5 py-3 ${isDark ? 'text-white/50' : 'text-gray-500'}`} data-id="element-2987">
                  Swatch
                </th>
                <th className={`text-left text-[11px] font-bold uppercase tracking-wider px-5 py-3 ${isDark ? 'text-white/50' : 'text-gray-500'}`} data-id="element-2988">
                  Hex
                </th>
                <th className={`text-left text-[11px] font-bold uppercase tracking-wider px-5 py-3 ${isDark ? 'text-white/50' : 'text-gray-500'}`} data-id="element-2989">
                  Tailwind Class
                </th>
              </tr>
            </thead>
            <tbody data-id="element-2990">
              {TIERS.map((tier, i) => <tr key={tier.name} className={`${isDark ? i % 2 === 0 ? 'bg-transparent' : 'bg-white/[0.02]' : i % 2 === 0 ? 'bg-transparent' : 'bg-gray-50/50'} ${isDark ? 'border-t border-white/5' : 'border-t border-gray-100'}`} data-id="element-2991">
                  <td className="px-5 py-3" data-id="element-2992">
                    <span className={`text-sm font-semibold ${isDark ? 'text-white/80' : 'text-gray-800'}`} data-id="element-2993">
                      {tier.name}
                    </span>
                  </td>
                  <td className="px-5 py-3" data-id="element-2994">
                    <span className={`text-[9px] font-bold px-2 py-1 rounded border ${isDark ? `${tier.tailwind} ${tier.bg} ${tier.border}` : `${tier.lightText} ${tier.lightBg} ${tier.lightBorder}`}`} data-id="element-2995">
                      {tier.name}
                    </span>
                  </td>
                  <td className="px-5 py-3" data-id="element-2996">
                    <span className={`text-sm ${isDark ? 'text-white/60' : 'text-gray-600'}`} data-id="element-2997">
                      {tier.color}
                    </span>
                  </td>
                  <td className="px-5 py-3" data-id="element-2998">
                    <div className="flex items-center gap-2" data-id="element-2999">
                      <div className="w-6 h-6 rounded-md border border-white/10" style={{
                    backgroundColor: tier.hex
                  }} data-id="element-3000" />
                      <div className="w-6 h-6 rounded-md border border-white/10" style={{
                    backgroundColor: tier.hex,
                    opacity: 0.2
                  }} data-id="element-3001" />
                    </div>
                  </td>
                  <td className="px-5 py-3" data-id="element-3002">
                    <code className={`text-xs font-mono px-2 py-0.5 rounded ${isDark ? 'bg-white/5 text-white/70' : 'bg-gray-100 text-gray-700'}`} data-id="element-3003">
                      {tier.hex}
                    </code>
                  </td>
                  <td className="px-5 py-3" data-id="element-3004">
                    <code className={`text-xs font-mono px-2 py-0.5 rounded ${isDark ? 'bg-white/5 text-white/70' : 'bg-gray-100 text-gray-700'}`} data-id="element-3005">
                      {tier.tailwind}
                    </code>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}